import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable()
export class Mastermgtservice {
  constructor(private http: HttpClient) {
  }

  baseUrl: string = environment.serviceUrl;

  getdata(userid): Observable<any> {       
    return this.http.get(
      this.baseUrl + 'api/MastermgtApi/getmasterdetails/' + userid, {  }
    );
  }
  

}
